import React from "react";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../images/defaultImage.png";

const InstagramAccess = ({ data, count }: any) => {
  const history = useNavigate();

  const onConnect = (item: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    if (fbPageInfo) {
      const recFbPageInfp = JSON.parse(fbPageInfo);
      if (recFbPageInfp) {
        localStorage.setItem("fbPageDetail", "");
      }
    }
    localStorage.setItem("fbPageDetail", JSON.stringify(item));
    history("/dashboard/instatemplates");
  };

  return (
    <>
      <div className="text-center">
        <h3 className="fbtext">
          {data && count ? (
            <div>
              We found {count ? count : 0} Instagram Accounts managed by you.
            </div>
          ) : (
            <div>Fetching Instagram Accounts.</div>
          )}
        </h3>
      </div>
      <div
        className="custom-scrollbar-css p-2"
        style={{ maxHeight: "65vh", overflowY: "auto" }}>
        {data && count > 0
          ? data.map((item: any, index: any) => {
              return (
                <div className="card" key={index}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="widgets_div d-flex align-items-center">
                        <div className="icon_div">
                          <span>
                            <img
                              src={item?.instagram?.instaProfilePic || defaultImage}
                              className="rounded-circle avatar-sm"
                              alt=""
                              onError={(e) => {
                                (e.target as HTMLImageElement).src = defaultImage;
                              }}
                            />
                          </span>
                        </div>
                        <div className="av-div">
                          {item?.instagram?.instaName}
                        </div>
                      </div>
                      <div className="text-right">
                        <button
                          type="button"
                          className="btn rounded-pill btn-small btn-sm btn-primary"
                          style={{ float: "right" }}
                          onClick={() => onConnect(item)}>
                          Access
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </>
  );
};

export default InstagramAccess;
